<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="onExportPdf"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="onExportExcel"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="input-icon mb-2 position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <input
              type="text"
              class="form-control date-range bookingrange"
              ref="dateRangeInput"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
          </div>

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              :class="{ active: isCollapsed }"
              @click="toggleCollapse"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Filters Panel -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row g-2 align-items-end">
            <div class="col-lg-3 col-md-6">
              <label class="form-label">Search</label>
              <input
                v-model="dash.filters.q"
                type="text"
                class="form-control"
                placeholder="Deal, company, contact, email..."
              />
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="form-label">Status</label>
              <select v-model="dash.filters.status" class="form-select">
                <option value="">All</option>
                <option v-for="s in dash.statuses" :key="s" :value="s">
                  {{ s }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="form-label">Pipeline</label>
              <select
                v-model="dash.filters.pipeline_id"
                class="form-select"
                @change="onPipelineChanged"
              >
                <option :value="null">All</option>
                <option v-for="p in dash.pipelines" :key="p.id" :value="p.id">
                  {{ p.name }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="form-label">Stage</label>
              <select
                v-model="dash.filters.stage_id"
                class="form-select"
                :disabled="!dash.selectedPipeline"
              >
                <option :value="null">All</option>
                <option
                  v-for="s in dash.stageOptions"
                  :key="s.id"
                  :value="s.id"
                >
                  {{ s.name }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="form-label">Owner</label>
              <select v-model="dash.filters.owner_id" class="form-select">
                <option :value="null">All</option>
                <option v-for="o in dash.owners" :key="o.id" :value="o.id">
                  {{ o.name }}
                </option>
              </select>
            </div>

            <div class="col-lg-1 col-md-6 d-grid">
              <button
                class="btn btn-primary"
                @click="applyFilters"
                :disabled="dash.loading || dash.metaLoading"
              >
                <span v-if="dash.loading"
                  ><i class="ti ti-loader me-1"></i
                ></span>
                Apply
              </button>
            </div>

            <!-- Phase 3 controls -->
            <div class="col-12 mt-2">
              <div
                class="d-flex flex-wrap gap-2 align-items-center justify-content-between"
              >
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <button
                    class="btn btn-light"
                    @click="resetFilters"
                    :disabled="dash.loading"
                  >
                    Reset
                  </button>

                  <div class="form-check form-switch ms-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoRefresh"
                      v-model="dash.autoRefresh"
                    />
                    <label class="form-check-label" for="autoRefresh">
                      Auto refresh
                    </label>
                  </div>

                  <div
                    class="text-muted small d-flex align-items-center"
                    v-if="dash.metaLoading"
                  >
                    <i class="ti ti-loader me-1"></i> Loading filter options...
                  </div>
                  <div
                    class="text-muted small d-flex align-items-center"
                    v-if="dash.exporting"
                  >
                    <i class="ti ti-loader me-1"></i> Exporting...
                  </div>
                  <div
                    class="text-muted small d-flex align-items-center"
                    v-if="dash.autoRefresh"
                  >
                    Debounce: {{ dash.debounceMs }}ms
                  </div>
                </div>

                <!-- Presets -->
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <div class="dropdown">
                    <button
                      class="btn btn-white border btn-sm dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i class="ti ti-bookmark me-1"></i>Presets
                    </button>
                    <ul
                      class="dropdown-menu dropdown-menu-end p-2"
                      style="min-width: 260px"
                    >
                      <li class="px-2 pb-2">
                        <div class="input-group">
                          <input
                            v-model="presetName"
                            class="form-control form-control-sm"
                            placeholder="Preset name..."
                          />
                          <button
                            class="btn btn-sm btn-primary"
                            @click="savePresetNow"
                            :disabled="!presetName.trim()"
                          >
                            Save
                          </button>
                        </div>
                        <div class="text-muted small mt-1">
                          Saves current filters + date range.
                        </div>
                      </li>

                      <li><hr class="dropdown-divider" /></li>

                      <li
                        v-if="!dash.presets?.length"
                        class="px-3 py-2 text-muted small"
                      >
                        No presets saved yet.
                      </li>

                      <li
                        v-for="p in dash.presets"
                        :key="p.id"
                        class="d-flex align-items-center justify-content-between px-2 py-1"
                      >
                        <a
                          class="dropdown-item rounded-1 flex-grow-1"
                          href="javascript:void(0);"
                          @click="applyPresetNow(p)"
                        >
                          {{ p.name }}
                        </a>
                        <button
                          class="btn btn-sm btn-light ms-2"
                          title="Delete"
                          @click.stop="deletePresetNow(p)"
                        >
                          <i class="ti ti-trash"></i>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <button
                    class="btn btn-white border btn-sm"
                    @click="dash.fetchDashboard({}, { force: true })"
                    :disabled="dash.loading"
                  >
                    <i class="ti ti-refresh me-1"></i>Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="text-muted small mt-2">
            ✅ You can click charts to drill down (Stage/Pipeline), and
            auto-refresh will react to filter changes.
          </div>
        </div>
      </div>

      <div v-if="dash.error" class="alert alert-danger mb-3">
        {{ dash.error }}
      </div>

      <total-deals />
      <deals-stages />
      <country-deals />
      <recent-deals />
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";

import { ref, onMounted, watch } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";

import TotalDeals from "./total-deals.vue";
import DealsStages from "./deals-stages.vue";
import CountryDeals from "./country-deals.vue";
import RecentDeals from "./recent-deals.vue";

import { useDealDashboardStore } from "@/stores/dealDashboardStore";
import { downloadBlob, filenameFromHeaders } from "@/utils/fileDownload";
import * as Toast from "@/utils/toast";

const toastError = (msg) => {
  if (Toast?.toast?.error) return Toast.toast.error(msg);
  if (typeof Toast?.toast === "function") return Toast.toast(msg, "error");
  if (Toast?.error) return Toast.error(msg);
  console.error(msg);
};
const toastSuccess = (msg) => {
  if (Toast?.toast?.success) return Toast.toast.success(msg);
  if (typeof Toast?.toast === "function") return Toast.toast(msg, "success");
  if (Toast?.success) return Toast.success(msg);
  console.log(msg);
};

const title = "Deals Dashboard";
const text = "Dashboard";
const text1 = "Deals Dashboard";

const isCollapsed = ref(false);
const dateRangeInput = ref(null);

const dash = useDealDashboardStore();

// preset input
const presetName = ref("");

function toggleCollapse() {
  isCollapsed.value = !isCollapsed.value;
  if (isCollapsed.value) document.body.classList.add("header-collapse");
  else document.body.classList.remove("header-collapse");
}

function toYmd(m) {
  return m.format("YYYY-MM-DD");
}

function setPickerText(start, end) {
  if (!dateRangeInput.value) return;
  dateRangeInput.value.value = `${start.format("DD/MM/YYYY")} - ${end.format(
    "DD/MM/YYYY"
  )}`;
}

async function applyRange(start, end) {
  dash.filters.date_from = toYmd(start);
  dash.filters.date_to = toYmd(end);
  setPickerText(start, end);
  await dash.fetchDashboard();
}

function onPipelineChanged() {
  // pipeline changes => stage must be cleared
  dash.filters.stage_id = null;
}

async function applyFilters() {
  await dash.fetchDashboard({}, { force: true });
}

async function resetFilters() {
  dash.resetFilters({ keepDates: true });
  await dash.fetchDashboard({}, { force: true });
}

async function onExportPdf() {
  try {
    const res = await dash.exportPdf();
    const filename = filenameFromHeaders(
      res.headers,
      `deals_dashboard_${moment().format("YYYYMMDD_HHmmss")}.pdf`
    );
    downloadBlob(res.data, filename);
    toastSuccess("PDF downloaded");
  } catch (e) {
    toastError(e?.response?.data?.message || "Failed to export PDF");
  }
}

async function onExportExcel() {
  try {
    const res = await dash.exportExcel();
    const filename = filenameFromHeaders(
      res.headers,
      `deals_dashboard_${moment().format("YYYYMMDD_HHmmss")}.csv`
    );
    downloadBlob(res.data, filename);
    toastSuccess("Excel (CSV) downloaded");
  } catch (e) {
    toastError(e?.response?.data?.message || "Failed to export Excel");
  }
}

function savePresetNow() {
  dash.savePreset(presetName.value);
  presetName.value = "";
}

async function applyPresetNow(p) {
  dash.applyPreset(p);
  // when a preset applies pipeline, ensure stage remains valid; if not, keep stage_id as preset value (backend will handle)
  await dash.fetchDashboard({}, { force: true });
}

function deletePresetNow(p) {
  dash.deletePreset(p.id);
}

// ✅ Phase 3: Debounced auto-refresh on filters (excluding date change via picker which already fetches)
let t = null;
watch(
  () => ({
    q: dash.filters.q,
    status: dash.filters.status,
    pipeline_id: dash.filters.pipeline_id,
    stage_id: dash.filters.stage_id,
    owner_id: dash.filters.owner_id,
    // include limit too
    limit: dash.filters.limit,
  }),
  () => {
    if (!dash.autoRefresh) return;
    if (t) clearTimeout(t);
    t = setTimeout(() => {
      dash.fetchDashboard({}, { force: true }).catch(() => {});
    }, Number(dash.debounceMs || 600));
  },
  { deep: true }
);

onMounted(async () => {
  await dash.fetchMeta();

  // init date range
  const start = moment().subtract(6, "days");
  const end = moment();

  if (dateRangeInput.value) {
    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      (s, e) => applyRange(s, e)
    );

    await applyRange(start, end);
  } else {
    dash.filters.date_from = start.format("YYYY-MM-DD");
    dash.filters.date_to = end.format("YYYY-MM-DD");
    await dash.fetchDashboard({}, { force: false });
  }
});
</script>


